import type { RouterOptions } from '@nuxt/schema';

export default <RouterOptions>{
  scrollBehavior(to, from, savedPosition) {
    // Ако постоји сачувана позиција (нпр. Back/Forward), врати је
    if (savedPosition) {
      return savedPosition;
    }
    // Ако постоји hash (#id), скролуј до тог елемента
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth', // За глатко скроловање
      };
    }
    // Подразумевано скролуј на врх
    return { top: 0 };
  },
};